"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailOutlined = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var EmailOutlined = function EmailOutlined() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.6 2H2.4C1.07452 2 0 3.07452 0 4.4V18.8C0 20.1255 1.07452 21.2 2.4 21.2H21.6C22.9255 21.2 24 20.1255 24 18.8V4.4C24 3.07452 22.9255 2 21.6 2ZM21.6 4.4V7.88L12.78 14.06C12.311 14.3855 11.689 14.3855 11.22 14.06L2.4 7.88V4.4H21.6ZM2.4 10.4V18.8H21.6V10.4L13.98 15.728C12.7909 16.5592 11.2091 16.5592 10.02 15.728L2.4 10.4Z",
    clipRule: "evenodd"
  });
};

exports.EmailOutlined = EmailOutlined;